import { render, staticRenderFns } from "./SectionRow.vue?vue&type=template&id=230bfc23"
import script from "./SectionRow.vue?vue&type=script&lang=js"
export * from "./SectionRow.vue?vue&type=script&lang=js"
import style0 from "./SectionRow.vue?vue&type=style&index=0&id=230bfc23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports